import React from "react";
import { Link, useLocation } from "react-router-dom";
import './NotFoundPage.css';
import {IoMdHome} from "react-icons/io";

const NotFoundPage = () => {
    const location = useLocation();

    const basePath = location.pathname.includes("/dashboard") ? "/dashboard/home" : "/";

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <h1 className="not-found-title">404</h1>
                <p className="not-found-description">
                    სამწუხაროდ, არაფერი მოიძებნა.
                </p>
                <p className="suggestion">
                    თქვენს მიერ მითითებული გვერდი ვერ მოიძებნა ან გვერდი წაიშალა.
                </p>
                <Link to={basePath} className="home-button">
                    <IoMdHome /> მთავარი გვერდი
                </Link>

            </div>
        </div>
    );
};

export default NotFoundPage;
